import React, { Component } from "react";

export default class Education extends Component {
  render() {
    return (
      <>
        <h2 className="heading">Education</h2>
        <div className="resume-wrap d-flex ftco-animate">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="flaticon-ideas"></span>
          </div>
          <div className="text pl-3">
            <span className="date">2017-2020</span>
            <h2>Computer Program Analyst (Computer Science)</h2>
            <span className="position">Fanshawe College</span>
            <p>
              Learned about Object-oriented development in both Windows and
              Linux-based client/server systems
            </p>
            <p>Software development & Web development</p>
            <p>Client/server web development (both .NET and J2EE)</p>
            <p>Database development (MSSQL and Oracle)</p>
            <p>
              Code level graphics, animation and simulation with C++ and DirectX
            </p>
            <p>Computer Architecture</p>
            <p>Software Design and Architecture</p>
            <p>Data Structures and Algorithms</p>
          </div>
        </div>
      </>
    );
  }
}
